// Cart Drawer functionality
(function() {
  'use strict';

  if (typeof theme === 'undefined') {
    console.error('Theme object not found. Make sure theme.js is loaded before cart-drawer.js');
    return;
  }

  theme.CartDrawer = new function () {
    var _ = this;
    var $drawer = null;
    var isOpen = false;
    var currentSlide = 0;
    var giftNoteTimeout = null;

    _.init = function () {
      $drawer = $('#cart-drawer');
      if (!$drawer.length) return;

      // Close drawer handlers
      $(document).on('click', '[data-cart-drawer-close]', function (e) {
        e.preventDefault();
        _.close();
      });

      // Open drawer handler (for cart icon)
      $(document).on('click', '[data-cart-drawer-toggle]', function (e) {
        e.preventDefault();
        _.open();
      });

      // Close on ESC key
      $(document).on('keydown', function (e) {
        if (e.keyCode === 27 && isOpen) {
          _.close();
        }
      });

      // Cart item update handlers
      $(document).on('click', '[data-cart-item-update]', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var line = $btn.data('line');
        var quantity = $btn.data('quantity');
        _.updateItem(line, quantity);
      });

      $(document).on('change', '.cart-drawer__quantity-input', function () {
        var $input = $(this);
        var line = $input.data('line');
        var quantity = parseInt($input.val()) || 0;
        if (quantity === parseInt($input.data('initial-value'))) {
          return; // No change
        }
        _.updateItem(line, quantity);
      });

      // Gift card notes handler
      $(document).on('input', '.cart-drawer__gift-notes-input', function () {
        var $textarea = $(this);
        var line = $textarea.data('line');
        var note = $textarea.val();
        console.log(note + " note")
        _.updateGiftCardNote(line, note);
      });

      // Cart item remove handler
      $(document).on('click', '[data-cart-item-remove]', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var line = $btn.data('line');
        _.updateItem(line, 0);
      });

      // Gift product add handler
      $(document).on('click', '[data-gift-product-id]', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var variantId = $btn.data('gift-product-id');
        _.addGiftProduct(variantId);
      });

      // Gift slider navigation
      $(document).on('click', '[data-gift-slider-prev]', function (e) {
        e.preventDefault();
        _.giftSliderPrev();
      });

      $(document).on('click', '[data-gift-slider-next]', function (e) {
        e.preventDefault();
        _.giftSliderNext();
      });

      // Cart note handler - use Shopify's cartNoteMonitor if available
      var $noteInput = $('#cart-drawer #note');
      if ($noteInput.length) {
        if (theme.cartNoteMonitor) {
          theme.cartNoteMonitor.load($noteInput);
        }
      }
    };

    _.open = function () {
      if (!$drawer || !$drawer.length) return;
      isOpen = true;
      $drawer.attr('aria-hidden', 'false').addClass('cart-drawer--open');
      $('body').addClass('cart-drawer-open');
      _.refresh();
      _.initGiftSlider();
    };

    _.close = function () {
      if (!$drawer || !$drawer.length) return;
      isOpen = false;
      $drawer.attr('aria-hidden', 'true').removeClass('cart-drawer--open');
      $('body').removeClass('cart-drawer-open');
    };

    _.refresh = function () {
      if (!$drawer || !$drawer.length) return;
      
      var sectionId = $drawer.closest('[data-section-id]').data('section-id');
      if (!sectionId) {
        // Fallback to cart API
        $.get(theme.routes.cart_url + '.js', function (cart) {
          _.renderCart(cart);
        });
        return;
      }
      
      // Use section API for proper rendering
      fetch(window.Shopify.routes.root + '?section_id=' + sectionId)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          var $newContent = $($.parseHTML('<div>' + html + '</div>'));
          var $newDrawer = $newContent.find('#cart-drawer');
          if ($newDrawer.length) {
            $drawer.find('.cart-drawer__content').html($newDrawer.find('.cart-drawer__content').html());
            // Update header
            $drawer.find('.cart-drawer__header').html($newDrawer.find('.cart-drawer__header').html());
            // Re-initialize accordions if needed
            if (theme.Sections && theme.Sections.initSection) {
              theme.Sections.initSection($drawer[0]);
            }
            // Re-initialize gift slider
            _.initGiftSlider();
            // Re-initialize cart note monitor
            var $noteInput = $('#cart-drawer #note');
            if ($noteInput.length && theme.cartNoteMonitor) {
              theme.cartNoteMonitor.load($noteInput);
            }
          }
        })
        .catch(function() {
          // Fallback to cart API
          $.get(theme.routes.cart_url + '.js', function (cart) {
            _.renderCart(cart);
          });
        });
    };

    _.renderCart = function (cart) {
      if (!$drawer || !$drawer.length) return;

      // Update header cart count
      $('#site-control .cart').find('div').text(cart.item_count);
    };

    _.updateItem = function (line, quantity) {
      var $item = $drawer.find('[data-cart-item]').eq(line - 1);
      $item.addClass('cart-drawer__item--updating');

      // Use Shopify's cart change API following their documentation
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        _.refresh();
        // Update header cart
        $.get(theme.routes.cart_url, function (data) {
          var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find('#site-control .cart:not(.nav-search)');
          $('#site-control .cart:not(.nav-search)').replaceWith($newCartObj);
        });
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      })
      .catch(function(error) {
        console.error('Cart update error:', error);
        _.refresh();
      });
    };

    _.updateGiftCardNote = function (line, note) {
      // Debounce the note update
      clearTimeout(_.giftNoteTimeout);
      _.giftNoteTimeout = setTimeout(function() {
        // Get current cart to find the item and preserve existing properties
        fetch(theme.routes.cart_url + '.js')
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Failed to fetch cart');
            }
            return response.json();
          })
          .then(function(cart) {
            // Validate cart response
            if (!cart || !cart.items || !Array.isArray(cart.items)) {
              console.error('Invalid cart response:', cart);
              return;
            }
            
            var item = cart.items[line - 1];
            if (!item) {
              console.error('Item not found at line:', line);
              return;
            }
            
            // Build properties object, preserving all existing properties
            var properties = {};
            
            // Copy existing properties
            if (item.properties) {
              // Handle both object and array formats
              if (Array.isArray(item.properties)) {
                // Properties as array of {name, value} objects
                item.properties.forEach(function(prop) {
                  if (prop.name !== 'Gift Wrap Note') {
                    properties[prop.name] = prop.value;
                  }
                });
              } else {
                // Properties as object
                for (var key in item.properties) {
                  if (item.properties.hasOwnProperty(key) && key !== 'Gift Wrap Note') {
                    properties[key] = item.properties[key];
                  }
                }
              }
            }
            
            // Add or remove Gift Card Message
            if (note && note.trim()) {
              properties['Gift Wrap Note'] = note.trim();
            }
            
            // Use cart/change.js API to update the specific line item with properties
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: line,
                quantity: item.quantity,
                properties: properties
              })
            });
          })
          .then(function(response) {
            if (!response) return; // Early return if validation failed
            if (!response.ok) {
              throw new Error('Failed to update cart');
            }
            return response.json();
          })
          .then(function(cart) {
            if (!cart) return; // Early return if validation failed
            // Refresh the drawer to show updated properties
            _.refresh();
            document.dispatchEvent(new CustomEvent('theme:cartchanged'));
          })
          .catch(function(error) {
            console.error('Gift note update error:', error);
          });
      }, 500);
    };

    _.addGiftProduct = function (variantId) {
      $.ajax({
        url: theme.routes.cart_add_url + '.js',
        type: 'POST',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        success: function (item) {
          _.refresh();
          // Update header cart
          $.get(theme.routes.cart_url, function (data) {
            var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find('#site-control .cart:not(.nav-search)');
            $('#site-control .cart:not(.nav-search)').replaceWith($newCartObj);
          });
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        }
      });
    };


    _.giftSliderStep = function ($slider) {
      var width = $slider[0].clientWidth;
      var gap = parseFloat(getComputedStyle($slider[0]).columnGap) || 10;
      return (width + gap) / 2;
    };

    _.giftSliderGo = function (index) {
      var $slider = $('[data-gift-slider]');
      if (!$slider.length) return;
      var $items = $slider.find('.cart-drawer__gift-item');
      var maxSlide = Math.max(0, $items.length - 2);
      currentSlide = Math.max(0, Math.min(maxSlide, index));
      $slider.css('transform', 'translateX(-' + (currentSlide * _.giftSliderStep($slider)) + 'px)');
    };

    _.giftSliderPrev = function () {
      _.giftSliderGo(currentSlide - 1);
    };

    _.giftSliderNext = function () {
      _.giftSliderGo(currentSlide + 1);
    };

    _.initGiftSlider = function () {
      var $slider = $('[data-gift-slider]');
      if (!$slider.length) return;
      currentSlide = 0;
      $slider.css('transform', 'translateX(0)');
    };
  }();

  // Cart Drawer Section
  theme.CartDrawerSection = new function () {
    this.onSectionLoad = function (target) {
      theme.CartDrawer.init();
      
      // Initialize cart note monitor if available
      var $noteInput = $('#note', target);
      if ($noteInput.length && theme.cartNoteMonitor) {
        theme.cartNoteMonitor.load($noteInput);
      }
    };

    this.onSectionUnload = function (target) {
      var $noteInput = $('#note', target);
      if ($noteInput.length && theme.cartNoteMonitor) {
        theme.cartNoteMonitor.unload($noteInput);
      }
    };
  }();
})();

